import React from "react";
import { api, errorMessage } from "../lib/api";
import { Download } from "lucide-react";

export default function QRDialog({ product, onClose }) {
    const baseUrl = window.location.origin;
    const qrSrc = `${api.defaults.baseURL}/products/${product.id}/qr?base_url=${encodeURIComponent(baseUrl)}`;
    const targetUrl = `${baseUrl}/p/${product.slug}`;

    const handleDownload = async () => {
        try {
            const res = await api.get(`/products/${product.id}/qr`, {
                params: { base_url: baseUrl },
                responseType: "blob",
            });
            const url = URL.createObjectURL(res.data);
            const a = document.createElement("a");
            a.href = url;
            a.download = `qr-${product.slug}.png`;
            document.body.appendChild(a);
            a.click();
            a.remove();
            URL.revokeObjectURL(url);
        } catch (e) {
            alert(errorMessage(e));
        }
    };

    return (
        <div
            data-testid="qr-dialog"
            className="fixed inset-0 z-50 grid place-items-center bg-black/50 p-4 backdrop-blur-sm"
            onClick={onClose}
        >
            <div
                className="w-full max-w-md rounded-xl border border-border bg-white p-6 fade-up"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="flex items-start justify-between gap-3">
                    <div>
                        <span className="label-eyebrow text-accent">QR Code</span>
                        <h3 className="mt-1 font-heading text-xl font-semibold">{product.name}</h3>
                        <p className="text-xs text-muted-foreground break-all">{targetUrl}</p>
                    </div>
                </div>
                <div className="mt-5 grid place-items-center rounded-lg border border-border bg-[#FDFBF7] p-6">
                    <img
                        src={qrSrc}
                        alt={`QR ${product.name}`}
                        className="h-64 w-64"
                        data-testid="qr-image"
                    />
                </div>
                <div className="mt-5 flex gap-2">
                    <button
                        onClick={onClose}
                        data-testid="qr-close-btn"
                        className="flex-1 rounded-full border border-border bg-white px-4 py-2.5 text-sm hover:bg-secondary transition-all duration-200"
                    >
                        Tutup
                    </button>
                    <button
                        onClick={handleDownload}
                        data-testid="qr-download-btn"
                        className="flex-1 inline-flex items-center justify-center gap-2 rounded-full bg-primary px-4 py-2.5 text-sm text-primary-foreground hover:opacity-90 transition-all duration-200"
                    >
                        <Download size={14} strokeWidth={1.75} /> Download PNG
                    </button>
                </div>
            </div>
        </div>
    );
}
